// src/HR/Assign_Course/dialogs/RescheduleDialog.jsx
import React from 'react';
import {
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    DialogContentText,
    IconButton,
    Box,
    Typography,
    List,
    ListItem,
    ListItemText,
    Paper
} from '@mui/material';
import { Close as CloseIcon, Warning as WarningIcon } from '@mui/icons-material';

const RescheduleDialog = ({ open, onClose, data, onReschedule, isMobile }) => {
    return (
        <Dialog
            open={open}
            onClose={onClose}
            maxWidth="sm"
            fullWidth
            sx={{ borderRadius: '12px' }}
        >
            <DialogTitle
                sx={{
                    display: 'flex',
                    justifyContent: 'space-between',
                    alignItems: 'center',
                    borderBottom: '1px solid #E7E8E9',
                    padding: '10px 24px',
                }}
            >
                <Box display="flex" alignItems="center" gap={1}>
                    <Typography variant="h6">Pending Assignment Found</Typography>
                </Box>
                <IconButton edge="end" color="inherit" onClick={onClose}>
                    <CloseIcon />
                </IconButton>
            </DialogTitle>

            <DialogContent className="my-4">
                <Box textAlign="center" mb={3}>
                    {/* <img
                        src="/images/warning-icon.png" // You can use your own warning image
                        alt="Warning"
                        style={{ width: 60, height: 60, marginBottom: 16 }}
                    /> */}
                    <WarningIcon sx={{ color: '#f59e0b', width: 60, height: 60, }} />

                    <DialogContentText>
                        {data?.message || "Employee already has a pending exam assignment."}
                    </DialogContentText>
                </Box>

                {data?.employees && data.employees.length > 0 && (
                    <Box mt={2}>
                        <Typography
                            variant="subtitle2"
                            sx={{
                                color: '#6b7280',
                                fontWeight: 600,
                                mb: 1
                            }}
                        >
                            Affected Employees:
                        </Typography>
                        <Paper
                            variant="outlined"
                            sx={{
                                maxHeight: '150px',
                                overflow: 'auto',
                                backgroundColor: '#f9fafb',
                                borderRadius: '8px'
                            }}
                        >
                            <List dense>
                                {data.employees.map((emp, index) => (
                                    <ListItem key={index} divider={index < data.employees.length - 1}>
                                        <ListItemText
                                            primary={emp.employeeName || emp.name || `Employee ${index + 1}`}
                                            secondary={`ID: ${emp.employeeId || emp.id || 'N/A'}`}
                                            primaryTypographyProps={{ fontSize: '0.9rem' }}
                                            secondaryTypographyProps={{ fontSize: '0.8rem' }}
                                        />
                                    </ListItem>
                                ))}
                            </List>
                        </Paper>
                    </Box>
                )}
            </DialogContent>

            <DialogActions
                sx={{
                    padding: '1rem',
                    borderTop: '1px solid #E7E8E9',
                    justifyContent: 'flex-end',
                    gap: 1
                }}
            >
                <button className="btn-negative" onClick={onClose}>
                    Cancel
                </button>
                {/* <button
                    className="btn"
                    onClick={onReschedule}
                    style={{ backgroundColor: '#f59e0b' }}
                >
                    Reschedule
                </button> */}
            </DialogActions>
        </Dialog>
    );
};

export default RescheduleDialog;